import { Button } from 'bricks/_landings';
import { SharedZoneBlocks, SharedZonePromoBlocks } from 'store/SharedZone/blocks/selectors';

const mapStateToProps = (state) => ({
  children: SharedZonePromoBlocks.getButtonText(state),
  url: SharedZonePromoBlocks.getUrl(state),
  isMedium: true,
});

export default SharedZoneBlocks.connect(mapStateToProps)(Button);
